import { render, staticRenderFns } from "./CDSSPages.vue?vue&type=template&id=71cba506&scoped=true&"
import script from "./CDSSPages.vue?vue&type=script&lang=js&"
export * from "./CDSSPages.vue?vue&type=script&lang=js&"
import style0 from "./CDSSPages.vue?vue&type=style&index=0&id=71cba506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cba506",
  null
  
)

export default component.exports